
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/[...setting_id]",
      function () {
        return require("private-next-pages/settings/[...setting_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/[...setting_id]"])
      });
    }
  